const locale = {
  LOADER_TEXT: 'Loading',
  MAIN_ARIA_LABEL: 'Main content',
  ASIDE_ARIA_LABEL: 'Navigation sidebar',
  FOOTER_ARIA_LABEL: 'Site footer',
  SKIP_TO_MAIN_CONTENT: 'Skip to main content',
};

export default locale;
